// extracted by mini-css-extract-plugin
export default {"root":"TextLine_root__QO5Zi"};